import React, {Component} from 'react';

import RestaurantCard from '../../components/RestaurantSettings/RestaurantCard/index';
import {IProps} from './IRestaurantCard';
import {
  getExtraCatalog,
  getKitchenTypeCatalog,
  getRestaurantTypeCatalog,
} from "../../api";

class RestaurantCardCont extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      establishmentCatalog: [],
      kitchenCatalog: [],
      extraCatalog: [],
    };
  }

  handleUpdateRestaurant = (info: {
    value: string | number | boolean | Array<string>, type: string
  }) => {
    const { currentRestaurant, updateRestaurantInfo } = this.props;

    if (currentRestaurant) {
      const updateData = {
        ...info,
        currentRestaurant,
      };

      updateRestaurantInfo(updateData);
    }
  };

  componentDidMount() {
    getRestaurantTypeCatalog().then(establishments => {
      if (establishments && Array.isArray(establishments)) {
        this.setState({ establishmentCatalog: establishments });
      }
    })
    getKitchenTypeCatalog().then((kitchen => {
      if (kitchen && Array.isArray(kitchen)) {
        this.setState({ kitchenCatalog: kitchen });
      }
    }))
    getExtraCatalog().then(extra => {
      if (extra && Array.isArray(extra)) {
        this.setState({ extraCatalog: extra });
      }
    })
  }

  restaurantInfoScrape = () => {
      const { scrapeRestaurantInfo, currentRestaurant } = this.props;
      if (currentRestaurant && currentRestaurant.id) {
        scrapeRestaurantInfo(currentRestaurant.id)
      }
    };

  render() {
    const {
      currentRestaurant,
      scrapeInfoLoading
    } = this.props;

    if (!currentRestaurant) {
      return null;
    }

    return (
      <RestaurantCard
        currentRestaurant={currentRestaurant}
        scrapeInfoLoading={scrapeInfoLoading}
        updateRestaurant={this.handleUpdateRestaurant}
        restaurantInfoScrape={this.restaurantInfoScrape}
        establishmentCatalog={this.state.establishmentCatalog}
        kitchenCatalog={this.state.kitchenCatalog}
        extraCatalog={this.state.extraCatalog}
      />
    );
  }
}

export default RestaurantCardCont;
